var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('button',{staticClass:"submit-btn",attrs:{"type":"button"},on:{"click":_vm.authorizeKlarnaPayment}},[_vm._v("\n    "+_vm._s(_vm.t('klarnaWidget.authorizeButton.text'))+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }